import { filterParam } from 'router/declarative/filterParam';
import { uriComponentParam } from 'router/declarative/paramRegistry';
import {
  IndexRouteContent,
  PathRouteContent,
  RouteNode,
} from 'router/declarative/routeNode';
import { AppModules } from '../appContainer/types';

export const routes = {
  path: '/solutions',
  appModule: AppModules.SOLUTIONS,
  content: async (): PathRouteContent =>
    (await import('./layout/SolutionsPageLayout')).SolutionsPageLayout,
  searchParams: { query: uriComponentParam, filter: filterParam },
  children: [
    {
      path: { index: true },
      content: async (): IndexRouteContent =>
        (await import('./landing/SolutionsPage')).SolutionsPage,
    },
    {
      path: '/:solutionId',
      content: async (): PathRouteContent =>
        (await import('./details/SolutionDetailPage')).SolutionDetailPage,
    },
  ],
} as const satisfies RouteNode;
